import React from 'react'

function Loading() {
  return (
    <div className='container-fluid loading'>
          <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
        </div>
    </div>
  )
}

export default Loading